export default __webpack_public_path__ + "static/logo-nmaahc-text-f143bac1eaa148e7df8fbe7b366a040f.png";